export const languageCode = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    dataList: null
  },
  getters: {
    dataList: state => state.dataList,
    isDataEmpty: state => !state.dataList
  },
  mutations: {
    set(state, payLoad) {
      state.dataList = payLoad;
    },
    clear(state) {
      state.dataList = null;
    }
  },
  actions: {
    /**
     * データセット
     */
    setData(context, payLoad) {
      context.commit('clear');
      context.commit('set', payLoad);
    },

    /**
     * データリセット
     */
    clearData(context) {
      context.commit('clear');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/status_list/language_code.js